import React, { useState, useEffect } from "react";
import "./CollectionDetails.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Scrollbars } from "react-custom-scrollbars";
import Api from "../../Common/api.jsx";
import { Link } from "react-router-dom";
import DateHelper from "../../Helpers/DateHelper.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { InlineShareButtons } from "sharethis-reactjs";
import SkeletonProduct ,{Row} from "../../Pages/Skeleton/index.jsx";


export default class CollectionDetails extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef()  
    this.applyFilter = false;
    this.timeout = 0;
    this.state = {
      filter: "",
      loader : false,
      loader1:false,
      loader2: false,
      loader3: false,
      collectionExploreArray: {},
      collectionActivityArray: [],
      collectionFeaturedNftArray: [],
      assets: [],
      id: "", //null,
      collection_id: "", //null,
      status: false,
      minprice: "", //null,
      maxPrice: "", //null,
      chain: [],
      category_id: "", //null,
      showVerifiedOnly: false,
      pageNumber: 1,
      pageSize: 20,
      chainConfigs: [],
      totalRecords: 0,
      isOwnAccount: false,
      account: "",
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });

    this.getCollectionFeturedNft();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    this.setState({ id: params.get("collectionId") }, () => {
      this.getChainConfigs();
      this.getCollection();
      this.getCollectionActivities();
      this.getFilteredAssets();
    });
  }

  executeScroll = () => this.myRef.current.scrollIntoView({behavior: 'smooth',block: 'nearest',inline: 'start'})

  showMore() {
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    if (this.state.pageNumber > totalPages) return;

    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.getFilteredAssets();
    });
  }

  getCollectionFeturedNft() {
    const api = new Api();
    this.setState({loader1: true});
    var parameter = "";

   // this.timeout = setTimeout(() => {
    api
      .get("get_featured_nft_collection/?pagesize=10&pagenumber=1", parameter)
      .then((response) => {
        this.setState({ collectionFeaturedNftArray: response.data });
        this.setState({loader1: false});
        //clearTimeout(this.timeout2);
      })
      .catch((err) => console.log(err));
   // }, 100000);
  }

  getChainConfigs() {
    const chainConfigs = new CommonHelper().getAllChainConfigs();

    this.setState({ chainConfigs: chainConfigs });
  }

  // scrollToTestDiv() {
  //   const divElement = document.getElementById("test");
  //   divElement.scrollIntoView({ behavior: "smooth" });
  // }

  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  handleChangeCheck = (e) => {
    this.setState({ status: e.target.checked });
    console.log(e.target.checked);
  };

  setFilterData(e) {
    this.setState({ showVerifiedOnly: e.target.checked });
  }
  setFilterCategoryData(id) {
    this.setState({ category_id: id, assets: [], totalRecords: 0 }, () => {
      this.getFilteredAssets();
    });
  }

  array = [];
 async setChainData(e) {
    console.log(e.target.checked,e.target.name,this.state.cha);
    if (e.target.checked) {
      this.array.push(e.target.name);
      await this.setState({ chain: [...new Set(this.array)] });
      console.log(this.state.chain);
    } else {
      this.array = this.array.filter(function (value, index, arr) {
        return value != e.target.name;
      });

      await this.setState({ chain:[...new Set(this.array)] });
    }
    console.log(this.state.chain);
  }

  async getCollection() {
    const api = new Api();
    this.setState({loader2: true});
    var parameter = "";

    this.timeout = setTimeout(() => {
    api
      .get("get_collection/?collection_id=" + this.state.id, {})
      .then((response) => {
        this.setState({ collectionExploreArray: response.data });
        this.setState({loader2: false});
        this.setState({ account: response.data.account });
        console.log(this.state.account);
        let accountloc = localStorage.getItem("accountId");
        if (accountloc) {
          console.log(
            this.state.account.toLocaleLowerCase(),
            accountloc.toLocaleLowerCase()
          );
          if (
            this.state.account.toLocaleLowerCase() ===
            accountloc.toLocaleLowerCase()
          ) {
            this.setState({ isOwnAccount: true });
          }
        } else {
          this.checkLoginAccount();
        }
        clearTimeout(this.timeout);
      })
      .catch((err) => console.log(err));

    console.log(this.state.isOwnAccount);
  }, 100);
  }
  async checkLoginAccount() {
    let loggedInAccount = await new MetaMaskService().getAccount();
    if (
      this.state.account.toLocaleLowerCase() ===
      loggedInAccount.toLocaleLowerCase()
    ) {
      this.setState({ isOwnAccount: true });
    }
  }
  getCollectionActivities() {
    const api = new Api();
    this.setState({loader3: true});
    var parameter = "";
    api
      .get("get_collection_activities/?collection_id=" + this.state.id, {})
      .then((response) => {
        this.setState({ collectionActivityArray: response.data });
        this.setState({loader3: false});
      })
      .catch((err) => console.log(err));
  }

  //Before applying the filter we need to reset some data
  searchAssets(id) {
    this.setState({ category_id: id, assets: [], totalRecords: 0 }, () => {
      console.log(this.state.category_id, "category_id");
      this.getFilteredAssets();
    });
    // this.setState({ assets: [], totalRecords: 0 }, () => {
    //   this.getFilteredAssets();
    // });
  }

  getFilteredAssets() {
    const api = new Api();
    this.setState({loader: true});
    const obj = {
      collection_id: this.state.id,
      minprice: this.state.minprice,
      maxPrice: this.state.maxPrice,
      chain: this.state.chain,
      category_id: this.state.category_id,
      showVerifiedOnly: this.state.showVerifiedOnly,
      pagenumber: this.state.pageNumber,
      pagesize: this.state.pageSize,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: obj,
    };

    // if (this.timeout) clearTimeout(this.timeout);
    // this.timeout = setTimeout(() => {
    api
      .post("filtered_assets/", obj)
      .then((response) => {
        this.setState({
          assets: this.state.assets.concat(response.data?.assets),
          totalRecords: response.data.totalRecords,
        });
        this.setState({loader: false});
      })
      .catch((err) => console.log(err));
   // },0);

    this.applyFilter = true;
    this.explorrerCollectionClose(1);
  }

  toggleMoreButton() {
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    return this.state.pageNumber < totalPages;
  }

  unCheck(i) {
    let ref = "ref_" + i;
    this.refs[ref].checked = !this.refs[ref].checked;
  }

  explorrerCollection() {
    document.body.classList.toggle("filterActive", "filter");
    document
      .querySelector(".filter-button")
      .classList.toggle("active", "filter");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.toggle("filter-open", "filter");
  }

  explorrerCollectionClose(flag) {
    document.body.classList.toggle("filter", "filterActive");
    document
      .querySelector(".filter-button")
      .classList.toggle("filter", "active");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.remove("filter-open");
    if (flag == 2) {
      //var x = document.getElementsByClassName("verifiedCheck");
      //this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
      this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
      this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
      this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;
      //x.checked = false;
      this.array=[]
      this.applyFilter = false;
      this.setState(
        {
          status: false,
          minprice: "",
          maxPrice: "",
          chain: [],
          category_id: null,
          assets: [],
          totalRecords: 0,
        },
        () => {
          this.getFilteredAssets();
          console.log("clear");
        }
      );
    }
  }

 async clearAll() {
    //this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
    this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
    this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
    this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;

    this.applyFilter = false;
    this.array=[]
    await this.setState({chain: []});
   await this.setState(
      {
        status: false,
        minprice: "",
        maxPrice: "",
        chain: [],
        category_id: null,
        //showVerifiedOnly: false,
        isInvalidUser: false,
        assets: [],
        totalRecords: 0,
      },
      () => {
        this.getFilteredAssets();
        console.log("clear");
      }
    );
    console.log(this.state.chain);
  }

  removeChain(flag) {
    console.log(this.state.chain[flag]);
    this.refs[this.state.chain[flag]].checked = false;
    var name = this.state.chain[flag];
    this.array = this.array.filter(function (value, index, arr) {
      return value != name;
    });
    this.setState({ chain: this.array });
  }
  // removeShowOnly() {
  //   this.refs["verifiedCheck"].checked = false;
  //   this.setState(
  //     {
  //       showVerifiedOnly: false,
  //     },
  //     console.log("clear")
  //   );
  // }
  removePrice() {
    this.setState(
      {
        minprice: "",
        maxPrice: "",
      },
      console.log("clear")
    );
  }
  getFormattedDateTime(date) {
    if (date) return new DateHelper().getFormattedDateTime(date);

    return "";
  }

  getMarketAddress(chain_id) {
    if (!this.state.chainConfigs) return "";

    var chainConfig = this.state.chainConfigs[chain_id];

    return chainConfig
      ? `${chainConfig.BLOCK_EXPLORER_URL}/address/${chainConfig.NFT_MARKETPLACE_ADDRESS}`
      : "";
  }

  getTransactionLink(chain_id, transaction_hash) {
    if (!this.state.chainConfigs) return "";

    var chainConfig = this.state.chainConfigs[chain_id];

    return chainConfig
      ? `${chainConfig.BLOCK_EXPLORER_URL}/tx/${transaction_hash}`
      : "";
  }

  getIcon(event_type) {
    return new CommonHelper().getIcon(event_type);
  }

  render = () => {
    return (
      <>
        <Header />
        <div class="container">
          <section className="collection-details">
            <section className="user-board">
              <div className="user-board__data-banner">
              {!this.state.loader2 ? (
                <img
                  className="user-board__imgbanner"
                  src={
                    this.state.collectionExploreArray.banner_image
                      ? this.state.collectionExploreArray.banner_image
                      : "../images/default_banner.png"
                  }
                  alt=""
                />
                ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items1" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
              </div>
              <div className="user-board__data">
                <div className="container">
                  <div className="user-board__data-img">
                  {!this.state.loader2 ? (
                    <img
                      className="user-board__img"
                      src={
                        this.state.collectionExploreArray.collection_image
                          ? this.state.collectionExploreArray.collection_image
                          : "../images/card1.png"
                      }
                      alt=""
                    />
                    ) :  [1].map(loading =>(
                      <>
                        <div className="skeleton-items1" key={loading}>
                        <SkeletonProduct />
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="user-board__data-ttl">
                    <h1>{this.state.collectionExploreArray.collection_name}</h1>
                  </div>
                  <div className="user-board__data-ttl__right">
                    {this.state.isOwnAccount && this.state.account ? (
                      <Link
                        className="button button__small"
                        to={"../EditCollection/?collectionId=" + this.state.id}
                      >
                        <img src="../images/svg/edit.svg" alt="" />
                        &nbsp; Edit Collection{" "}
                      </Link>
                    ) : (
                      <></>
                    )}
                    <ul className="info-share">
                      <li
                      style={{
                        display:
                          this.state.collectionExploreArray.discord == null
                            ? "none"
                            : "block",
                      }}
                      >
                        <Link
                          target={"_blank"}
                          to={{
                            pathname:
                              "/" + this.state.collectionExploreArray.discord,
                          }}
                        >
                          <img
                            className="discordIcon"
                            src="../images/Discord.png"
                            alt="Coin"
                          />
                        </Link>
                      </li>
                      <li
                      style={{
                        display:
                          this.state.collectionExploreArray.instagram == null
                            ? "none"
                            : "block",
                      }}
                      >
                        <Link
                          target={"_blank"}
                          to={{
                            pathname:
                              "/" + this.state.collectionExploreArray.instagram,
                          }}
                        >
                          {/* <i className="material-icons-outlined">open_in_new</i> */}
                          <img
                            className="instaIcon"
                            src="../images/Instagramlogo.png"
                            alt="Coin"
                          />
                        </Link>
                      </li>
                      <li style={{
                        display:
                          this.state.collectionExploreArray.telegram == null
                            ? "none"
                            : "block",
                      }}>
                        <Link
                          target={"_blank"}
                          to={{
                            pathname:
                              "/" + this.state.collectionExploreArray.telegram,
                          }}
                        >
                          {/* <i className="material-icons-outlined">share</i> */}
                          <img
                            className="telegramIcon"
                            src="../images/Telegramlogo.png"
                            alt="Coin"
                          />
                        </Link>
                      </li>
                      <li style={{
                        display:
                          this.state.collectionExploreArray.medium == null
                            ? "none"
                            : "block",
                      }}>
                        <Link
                          target={"_blank"}
                          to={{
                            pathname:
                              "/" + this.state.collectionExploreArray.medium,
                          }}
                        >
                          {/* <i className="material-icons-outlined">assistant_photo</i> */}
                          <img
                            className="mediumIcon"
                            src="../images/Mediumlogo.png"
                            alt="Coin"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="user-board__data-score">
                    <ul className="user-board__data-score__list">
                      <li>
                        <label>Items</label>{" "}
                        <h5>
                          {this.state.collectionExploreArray.total_assets}
                        </h5>
                      </li>
                      <li>
                        <label>Owners</label>{" "}
                        <h5>
                          {this.state.collectionExploreArray.total_owners}
                        </h5>
                      </li>
                      {/* <li>
                        <label>Floor Price</label>{" "}
                        <h5>
                          <img src="../images/eth.png" alt="eth" />
                          {this.state.collectionExploreArray.floor_price}
                        </h5>
                      </li>
                      <li>
                        <label>Total Volume</label>{" "}
                        <h5>
                          <img src="../images/eth.png" alt="eth" />{" "}
                          {this.state.collectionExploreArray.total_volume}
                        </h5>
                      </li> */}
                    </ul>
                    <div className="user-board__data-score__author">
                      <div className="img">
                        <img
                          src={
                            this.state.collectionExploreArray
                              .creator_profile_image
                              ? this.state.collectionExploreArray
                                  .creator_profile_image
                              : "../images/default_image.png"
                          }
                          alt="Artist1"
                        />
                      </div>
                      <div className="name">
                        <span>Creator</span>
                        <div>
                          <Link
                            className="link"
                            to={
                              "/UserProfile/?account=" +
                              this.state.collectionExploreArray.account
                            }
                          >
                            {" "}
                            {this.state.collectionExploreArray.created_by}{" "}
                          </Link>

                          {this.state.collectionExploreArray.isVerified ==
                          true ? (
                            <img
                              src="../images/svg/checked-badge.svg"
                              alt="badge"
                            />
                          ) : (
                            false
                          )}
                        </div>
                      </div>
                    </div>
                    <p className="para">
                      {this.state.collectionExploreArray.collection_description}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <div className="exploreCollections">
              <div className="container">
                <div className="filter-wrap">
                  <ul className="filter-list">
                    <li>
                      <a
                        className={
                          this.state.category_id == null ? "active" : ""
                        }
                        // onClick={() => this.setFilterCategoryData(null)}
                      >
                        {" "}
                        Items
                      </a>
                    </li>
                    <li>
                      <a
                        className={
                          this.state.category_id == this.state.id
                            ? "active"
                            : ""
                        }
                        // onClick={() => this.scrollToTestDiv()}
                        onClick={()=> this.executeScroll()}
                      >
                        Activity
                      </a>
                    </li>
                  </ul>
                  <div className="filter-wrap__btns">
                    <button
                      className="filter-button"
                      onClick={() => this.explorrerCollection()}
                    >
                      <div className="img-box">
                        <i className="material-icons-outlined">filter_list</i>
                      </div>
                      <span>Show Filters</span>
                    </button>
                    {/* <button className="filter-button">
                  <div className="img-box">
                    <i className="material-icons-outlined">sort</i>
                  </div>
                  <span>Sort</span>
                </button> */}
                  </div>
                  <div className="filter-wrap__search">
                    {/* <form className="filter-wrap__search-box">
                  <input type="text" className="input" placeholder="Search by name or trait" />
                  <button type="button">
                    <img src="../images/search.png" alt="Search" />
                  </button>
                </form> */}
                  </div>
                </div>
                <div className="filter-list-box-wrap">
                {!this.state.loader ? (
                  
                  <ul className="explore-nfts collection-details">
                    {this.state.assets?.length > 0  ? ( this.state.assets.map((filetrAssets, index) => (
                      <li key={index}>
                        {/* <a href={'../NftDetails/?assetId='+filetrAssets.asset_id} className="card"> */}
                        <Link
                          to={"../NftDetails/?assetId=" + filetrAssets.asset_id}
                          className="card"
                        >
                          <div className="card-img">
                            <img
                              src={filetrAssets.asset_image}
                              alt="discover"
                            />
                          </div>
                          <div className="card-body">
                            <div className="artist-block">
                              <div className="media">
                                <div className="media-body">
                                  <div className="media-body__left">
                                    <label
                                      style={{
                                        width: 120 + "px",
                                        whiteSpace: "nowrap",
                                        overflow: " hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {filetrAssets.asset_name}
                                    </label>
                                    {/* <p>FancyBirds</p> */}
                                  </div>
                                  <div className="media-body__right">
                                    <label>
                                      {/* <span>Price</span>  */}
                                      <img
                                        src={filetrAssets.currency_image}
                                        alt="eth"
                                      />{" "}
                                      {filetrAssets.price}
                                    </label>
                                    <label>
                                      {/* <span>Offer for</span>  */}
                                      {/* <img src={filetrAssets.currency_image}alt="eth"/> {filetrAssets.price}  */}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </li>
                    )))
                    :(
                    <li className="no-items-msg">
                       <h3>No Items</h3>                     
                      </li>)}
                  </ul>
                   ) :  [1, 2, 3, 4,5,6,7,8].map(loading =>(
                    <>
                      <div className="skeleton-items" key={loading}>
                      <SkeletonProduct />
                      </div>
                    </>
                  ))}

                {/* <ul className="explore-nfts collection-details">
                      <li>
                        <Link className="card">
                          <div className="card-img">
                          <span>No Collections</span>
                          </div>
                        </Link>
                      </li>
                  </ul> */}

                  <Scrollbars className="custmScrollbar">
                    <div className="filter-box">
                      <div className="filter-title">
                        <h4>Applied Filters</h4>
                        <button
                          className="clear-filter"
                          onClick={() => this.clearAll()}
                        >
                          Clear All
                        </button>
                      </div>
                      <ul className="applied-filter">
                        <li
                          style={{
                            display:
                              this.applyFilter &&
                              this.state.minprice != null &&
                              this.state.minprice != "" &&
                              this.state.maxPrice != null &&
                              this.state.maxPrice != ""
                                ? "inherit"
                                : "none",
                          }}
                        >
                          <span>
                            {this.state.minprice} To {this.state.maxPrice}
                          </span>
                          <a onClick={() => this.removePrice()}>
                            <img
                              onClick={() => this.removePrice()}
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                        {/* li end */}
                        <li
                          style={{
                            display:
                              this.applyFilter && this.state.chain[0]
                                ? "inherit"
                                : "none",
                          }}
                        >
                          <span>{this.state.chain[0]}</span>
                          <a onClick={() => this.removeChain(0)}>
                            <img
                              onClick={() => this.removeChain(0)}
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                        <li
                          style={{
                            display:
                              this.applyFilter && this.state.chain[1]
                                ? "inherit"
                                : "none",
                          }}
                        >
                          <span>{this.state.chain[1]}</span>
                          <a onClick={(e) => this.removeChain(1)}>
                            <img
                              onClick={(e) => this.removeChain(1)}
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                        <li
                          style={{
                            display:
                              this.applyFilter && this.state.chain[2]
                                ? "inherit"
                                : "none",
                          }}
                        >
                          <span>{this.state.chain[2]}</span>
                          <a onClick={() => this.removeChain(2)}>
                            <img
                              onClick={() => this.removeChain(2)}
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                        {/* li end */}
                        {/* <li
                        style={{
                          display:
                            this.applyFilter &&
                            this.state.showVerifiedOnly == true
                              ? "inherit"
                              : "none",
                        }}
                      >
                        <span>Show Verified Only</span>
                        <a onClick={() => this.removeShowOnly()}>
                          <img
                            onClick={() => this.removeShowOnly()}
                            src="../images/svg/white-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li> */}
                        {/* li end */}
                        {/* <li>
                        <span>Has Offers</span>
                        <a href="/">
                          <img
                            src="../images/svg/white-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li> */}
                        {/* li end */}
                      </ul>
                      {/* <div className="filter-title">
                      <h4>Status</h4>
                    </div> */}
                      {/* <ul className="filter-check-list">
                      <li>
                        <label htmlFor="buyNow">
                          <input
                            type="checkbox"
                            id="buyNow"
                            hidden
                            checked={this.state.status} 
                            onChange={this.handleChangeCheck} 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-white.svg"
                              alt="check"
                            />
                          </div>
                          <span>Buy Now</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="onAuction">
                          <input
                            type="checkbox"
                            id="onAuction"
                            hidden
                            defaultChecked
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-white.svg"
                              alt="check"
                            />
                          </div>
                          <span>On Auction</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="new">
                          <input
                            type="checkbox"
                            id="new"
                            hidden
                            defaultChecked
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-white.svg"
                              alt="check"
                            />
                          </div>
                          <span>New</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="hasOffer">
                          <input
                            type="checkbox"
                            id="hasOffer"
                            hidden
                            defaultChecked
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-white.svg"
                              alt="check"
                            />
                          </div>
                          <span>Has Offer</span>
                        </label>
                      </li>
                    </ul> */}
                      <div className="filter-title">
                        <h4>Price (in ETH)</h4>
                      </div>
                      <div className="price-range">
                        <input
                          type="text"
                          name="minprice"
                          id="min"
                          placeholder="min"
                          className="min"
                          value={this.state.minprice}
                          onChange={(e) => {
                            this.handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value,
                              },
                            });
                          }}
                        />
                        <span>to</span>
                        <input
                          type="text"
                          name="maxPrice"
                          id="max"
                          placeholder="max"
                          className="max"
                          value={this.state.maxPrice}
                          onChange={(e) => {
                            this.handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value,
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="filter-title">
                        <h4>Blockchains</h4>
                      </div>
                      <ul className="filter-check-list">
                        <li>
                          <label htmlFor="ethereum">
                            <input
                              type="checkbox"
                              id="ethereum"
                              ref="Ethereum"
                              hidden
                              //defaultChecked="false"
                              name="Ethereum"
                              onChange={(e) => this.setChainData(e)}
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/eth.png" alt="Verify" />
                            </div>
                            <span>Ethereum</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="polygon">
                            <input
                              type="checkbox"
                              id="polygon"
                              ref="Polygon"
                              hidden
                              //defaultChecked="false"
                              name="Polygon"
                              onChange={(e) => this.setChainData(e)}
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/poly.png" alt="Verify" />
                            </div>
                            <span>Polygon</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="solana">
                            <input
                              type="checkbox"
                              id="solana"
                              hidden
                              ref="Solana"
                              //defaultChecked="false"
                              name="Solana"
                              onChange={(e) => this.setChainData(e)}
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/sola.png" alt="Verify" />
                            </div>
                            <span>Solana</span>
                          </label>
                        </li>
                      </ul>
                      {/* <div className="filter-title">
                      <h4>Verification</h4>
                    </div>
                    <ul className="filter-check-list">
                      <li>
                        <label htmlFor="verified">
                          <input
                            type="checkbox"
                            id="verified"
                            ref="verifiedCheck"
                            hidden
                            // defaultChecked="false"
                            onChange={(e) => this.setFilterData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-white.svg"
                              alt="check"
                            />
                          </div>
                          <div className="icon">
                            <img src="../images/verify.png" alt="Verify" />
                          </div>
                          <span>Show only verified</span>
                        </label>
                      </li>
                    </ul> */}
                      <div className="filter-btn-wrap">
                        <button
                          onClick={() => this.searchAssets()}
                          className="button"
                        >
                          Apply
                        </button>
                        <button
                          className="button purple-outline"
                          onClick={() => this.explorrerCollectionClose(2)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Scrollbars>
                </div>
                <div className="button-wrap">
                  {this.toggleMoreButton() ? (
                    <button
                      onClick={(event) => this.showMore(event)}
                      className="button purple-outline"
                    >
                      Show More
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
                {/* <div className="nft-details__price-graph w-full">
                <div className="nft-details__price-graph-header">
                  <h6>Price History</h6>
                  <div className="select-dd">
                    <select>
                      <option value="item1">This Year</option>
                      <option value="item2">This Year 1</option>
                      <option value="item3">This Year 2</option>
                      <option value="item4">This Year 3</option>
                    </select>
                  </div>
                </div>
                <div className="nft-details__price-graph-bid">
                  <span>Top bid</span>
                  <div className="price">
                    
                    <img src="../images/eth.png" alt="eth" /> 88.069
                    <small>($176,986.10)</small>
                  </div>
                </div>
                <div className="nft-details__price-graph-area">
                  <img src="../images/graph1_large.png" alt="eth" />
                </div>
              </div> */}

              {!this.state.loader3 ? (
                <div className="nft-details__activity w-full" ref={this.myRef}>
                  {/* id="test"> */}
                  <div className="nft-details__activity-header">
                    <h6>Activity</h6>
                  </div>
                  <div className="nft-details__activity-table">
                    <Scrollbars className="custmScrollbar">
                    <table width="100%" cellSpacing="7px" cellPadding="0">
                      <thead>
                        <tr>
                          <th>Event</th>
                          <th>Item</th>
                          <th>Price</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.collectionActivityArray.map(
                          (collectionActivities, i) => (
                            <tr>
                              <td>
                                <i className="material-icons-outlined">
                                  {this.getIcon(
                                    collectionActivities.event_type
                                  )}
                                </i>
                                {"  "}
                                {collectionActivities.event_type}
                              </td>
                              <td>
                                <Link
                                  to={
                                    "../NftDetails/?assetId=" +
                                    collectionActivities.asset_id
                                  }
                                  className="item-img__wrapp link"
                                >
                                  <div className="item-img">
                                    <img
                                      src={collectionActivities.asset_image}
                                      alt="eth"
                                    />
                                  </div>
                                  {collectionActivities.item}
                                </Link>
                              </td>
                              <td>
                                {collectionActivities.price ? (
                                  <img
                                    className="prc"
                                    src={collectionActivities.currency_image}
                                    alt="eth"
                                  />
                                ) : (
                                  <></>
                                )}
                                {collectionActivities.price}
                              </td>

                              <td>
                                {collectionActivities.event_type == "Minted" ? (
                                  <a
                                    href={this.getMarketAddress(
                                      collectionActivities.chain_id
                                    )}
                                    target="_blank"
                                    className="link"
                                  >
                                    {"RedShilliz"}
                                  </a>
                                ) : (
                                  <Link
                                    to={
                                      "../UserProfile/?account=" +
                                      collectionActivities.from_owner_account
                                    }
                                    className="link"
                                  >
                                    {collectionActivities.from_owner
                                      ? collectionActivities.from_owner
                                      : "Unnamed"}
                                  </Link>
                                )}
                              </td>
                              <td>
                                <Link
                                  className="link"
                                  to={
                                    "/UserProfile/?account=" +
                                    collectionActivities.to_owner_account
                                  }
                                >
                                  {collectionActivities.to_owner}
                                </Link>
                              </td>
                              <td>
                                {collectionActivities.event_type !== "List" ? (
                                  <a
                                    target="_blank"
                                    href={this.getTransactionLink(
                                      collectionActivities.chain_id,
                                      collectionActivities.transaction_hash
                                    )}
                                    className="link"
                                  >
                                    {this.getFormattedDateTime(
                                      collectionActivities.time
                                    )}
                                    {"  "}
                                    <i className="material-icons-outlined blue-outline">
                                      open_in_new
                                    </i>
                                  </a>
                                ) : (
                                  this.getFormattedDateTime(
                                    collectionActivities.time
                                  )
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                    </Scrollbars> 
                  </div>
                </div>  ) : (
                    [...Array(5)].map((e, i) => (
                        <Row/>
                    ))
                  )}
                {/* <div className="button-wrap">
              <a href="/" className="button purple-outline">
                Show More
              </a>
            </div> */}
              </div>
            </div>
            <section className="featured-nft">
              <div className="container">
                <div className="section-title">
                  <h2>Collection Featured NFTs</h2>
                </div>
                {!this.state.loader1 ? (
                <ul className="nft-list">
                  {this.state.collectionFeaturedNftArray
                    .slice(0, 3)
                    .map((featureNftCollection, i) => (
                      <li key={i}>
                        <div className="img-group">
                          <div className="left-img">
                            {featureNftCollection.assets
                              .slice(0, 1)
                              .map((featureNftImg, i) => (
                                <Link
                                  to={
                                    "../NftDetails/?assetId=" +
                                    featureNftImg.asset_id
                                  }
                                >
                                  <img
                                    src={featureNftImg.image_loc}
                                    alt="Img"
                                  />
                                </Link>
                              ))}
                          </div>
                          <ul className="right-img">
                            {featureNftCollection.assets
                              .slice(1, 4)
                              .map((featureNftImg, i) => (
                                <li>
                                  <Link
                                    to={
                                      "../NftDetails/?assetId=" +
                                      featureNftImg.asset_id
                                    }
                                  >
                                    <img
                                      src={featureNftImg.image_thumbnail}
                                      alt="Img"
                                    />
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                        <div className="title-block">
                          <h2>{featureNftCollection.collection_name}</h2>
                          <div className="artist">
                            <div className="img-box">
                              <img
                                src={
                                  featureNftCollection.user_profile_pic
                                    ? featureNftCollection.user_profile_pic
                                    : "../images/default_image.png"
                                }
                                alt="Artist"
                              />
                            </div>
                            <div className="name">
                              {featureNftCollection.created_by}
                            </div>
                          </div>
                          {/* <a href="/" className="button outline total-item">
                          Total {featureNftCollection.num_of_asset} Items
                        </a> */}
                        </div>
                      </li>
                    ))}
                  {/* LI END */}
                </ul>
                 ) : (
                  [1, 2, 3,].map((loading) => (
                    <>
                      <div className="skeleton-items" key={loading}>
                        <SkeletonProduct />
                      </div>
                    </>
                  ))
                )}
              </div>
            </section>
          </section>
        </div>
        <Footer />
      </>
    );
  };
}
